// removed by extract-text-webpack-plugin
module.exports = {"link":"src-scripts-components-BackendSidebar-BackendSidebarLink-__backendSidebarLink___link","title":"src-scripts-components-BackendSidebar-BackendSidebarLink-__backendSidebarLink___title","active":"src-scripts-components-BackendSidebar-BackendSidebarLink-__backendSidebarLink___active","badge":"src-scripts-components-BackendSidebar-BackendSidebarLink-__backendSidebarLink___badge"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/BackendSidebar/BackendSidebarLink/backendSidebarLink.css
// module id = 2610
// module chunks = 0